/**
 * jQuery Stickify Plugin
 * Version: 1.0.7
 * Author: Len Bradley (lenbradley@ninesphere.com)
 *
 * Settings:
 *
 *     selector: The element to apply stickify to
 *     offset: The offset (margin) from the top that the element will activate and stick at
 *     spacerClass: The class that gets applied to the spacer
 *     stickyClass: The class that gets applied to the element that is stickied
 *     minHeight: The minimum height at which stickify is activated
 *     minWidth: The minimum width at which stickify is activated *
 *     moveWith: An element that will cause the stickied element to move up the page
 *     moveWithOffset: The offset (margin) that the moveWithOffset element will start moving at
 *     moveWithPos: (top|bottom) Whether to move with the top or bottom of element
 *     onWindowScroll: (true|false) Whether or not to stickify any time the window is scrolled
 *     preserveWidth: (true|false) Whether or not to save width of element when sticky
 *     applyCSS: Whether to apply general css styles to element to stick to window
 *     renderSpacer: (true|false) Whether or not to render spacer. This is useful with onWindowScroll option if element is a fixed positioned
 *     css: (object) CSS rules to apply if applyCSS is set to true
 *     staticMode : (true|false) If the element is initially static or absolute position set this to true to work correctly
 *
 * Example:
 *
 *     $('#header').stickify({
 *          moveWith: '#push-element',
 *          moveWithOffset: 50
 *      });
 */

(function($) {

    var Stickify = function( settings ) {

        this.args = {
            selector        : '',
            offset          : 0,
            spacerClass     : 'sticky-spacer',
            stickyClass     : 'is-sticky',
            minHeight       : 0,
            minWidth        : 0,
            moveWith        : 'parent',
            moveWithOffset  : 0,
            moveWithPos     : 'bottom',
            onWindowScroll  : false,
            preserveWidth   : true,
            applyCSS        : true,
            renderSpacer    : true,
            css             : {
                'position'  : 'fixed',
                'z-index'   : 50
            },
            staticMode      : false
        };

        if ( typeof settings === 'undefined' ) {
            settings = {};
        }

        if ( typeof settings === 'string' ) {
            settings = { selector : settings }
        }

        if ( typeof settings === 'object' ) {
            this.args = $.extend( true, {}, this.args, settings );
        }

        if ( this.args.staticMode ) {
            this.args.onWindowScroll    = true;
            this.args.renderSpacer      = false;
            this.args.preserveWidth     = false;
        }

        this.create = function() {

            if ( ! this.getElement() || ! this.getElement().length ) {
                return false;
            } else {

                var stickyElement = this;

                if ( typeof this.args.moveWith == 'string' ) {
                    if ( this.args.moveWith == 'parent' ) {
                        this.args.moveWith = stickyElement.getElement().parent();
                    } else {
                        this.args.moveWith = $(this.args.moveWith);
                    }
                }

                if ( typeof this.args.moveWith !== 'object' || ! this.args.moveWith.length ) {
                    this.args.moveWith = false;
                }

                stickyElement.args.stickyID  = 'stickify-' + ( Math.random().toString(36).substr( 2, 16 ) );
                stickyElement.getElement().addClass( this.args.stickyID );

                this.args.selector = ( typeof this.args.selector == 'string' ? this.args.selector : '' ) + '.' + this.getID();

                stickyElement.render();

                $(window).on( 'load scroll', function() {
                    stickyElement.render();
                });

                $(window).on( 'resize', function() {
                    stickyElement.unstick();
                    stickyElement.render();
                });
            }
        }

        this.destroy = function() {
            $(window).off( this.args.selector );
            this.unstick();
            this.args.selector = '';
        }

        this.render = function() {

            if ( this.needsSticky() ) {
                this.stick();
            } else {
                this.unstick();
            }
        }

        this.getID = function() {
            return this.args.stickyID;
        }

        this.getElement = function() {

            if ( typeof this.elObject === 'undefined' ) {

                if ( typeof this.args.selector === 'object' ) {
                    this.elObject = this.args.selector;
                }

                if ( typeof this.args.selector === 'string' ) {
                    this.elObject = $(this.args.selector);
                }
            }

            return this.elObject;
        }

        this.needsSticky = function() {

            if ( this.args.onWindowScroll ) {

                if ( $(window).scrollTop() ) {
                    return true;
                } else {
                    return false;
                }
            } else {

                var checkPosition = ( this.getElement().hasClass( this.args.stickyClass ) ? this.getSpacerTopPosition() : this.getElementTopPosition() );

                if (
                    checkPosition < this.args.offset
                    && $(window).height() >= this.args.minHeight
                    && $(window).width() >= this.args.minWidth )
                {
                    return true;
                } else {
                    return false;
                }
            }
        }

        this.stick = function() {

            this.renderSpacer();
            this.getElement().css( 'top', this.args.offset );

            if ( this.args.preserveWidth ) {
                this.getElement().css( 'width', this.getElement().width() );
            }

            var topPosition = this.args.offset;

            if ( this.args.moveWith && this.getElement().hasClass( this.args.stickyClass ) ) {

                var windowHeight        = $(window).height();
                var elemBottom          = this.getElementBottomPosition() + this.args.moveWithOffset;
                var moveWithPosition    = this.args.moveWith[0].getBoundingClientRect().top;

                if ( this.args.moveWithPos == 'bottom' ) {
                    moveWithPosition += this.args.moveWith.outerHeight();
                }

                if ( elemBottom > windowHeight ) {
                    elemBottom = windowHeight;
                }

                if ( elemBottom > moveWithPosition ) {
                    topPosition = ( moveWithPosition - elemBottom );
                }
            }

            this.getElement().css( 'top', topPosition ).addClass( this.args.stickyClass );

            if ( this.args.applyCSS ) {
                this.applyStyles();
            }
        }

        this.unstick = function() {

            this.removeSpacer();
            this.getElement().css( 'top', '' );

            if ( this.args.applyCSS ) {
                this.removeStyles();
            }

            if ( this.args.preserveWidth ) {
                this.getElement().css( 'width', '' );
            }

            this.getElement().removeClass( this.args.stickyClass );
        }

        this.getElementTopPosition = function() {

            var position = 0;

            if ( this.getElement().length ) {
                position = this.getElement()[0].getBoundingClientRect().top;
            }

            return position;
        }

        this.getElementBottomPosition = function() {

            var position = 0;

            if ( this.getElement().length ) {
                position = this.getElementTopPosition() + this.getElement().outerHeight();
            }

            return position;
        }

        this.getElementHeight = function() {

            var height = 0;

            if ( this.getElement().length ) {
                height = ( this.getElement().outerHeight( true ) );
            }

            return height;
        }

        this.getSpacer = function() {
            return $( '.' + this.args.spacerClass + '.' + this.getID() );
        }

        this.renderSpacer = function() {

            if ( ! this.args.renderSpacer ) {
                return false;
            } else {

                var spacerHeight = 0;

                if ( this.getElement().length && ! this.getSpacer().length ) {
                    this.getElement().after( '<div class="' + this.args.spacerClass + ' ' + this.getID() + '"></div>' );
                }

                if ( this.getElement().hasClass( this.args.stickyClass ) && this.getSpacer().length ) {
                    spacerHeight = this.getSpacer().height();
                } else {
                    spacerHeight = this.getElementHeight();
                }

                this.getSpacer().height( spacerHeight );
            }
        }

        this.removeSpacer = function() {
            this.getSpacer().remove();
        }

        this.getSpacerTopPosition = function() {

            var position = 0;

            if ( this.getSpacer().length ) {
                position = this.getSpacer()[0].getBoundingClientRect().top;
            }

            return position;
        }

        this.getSpacerBottomPosition = function() {

            var position = 0;

            if ( this.getSpacer().length ) {
                position = ( this.getSpacerTopPosition() + this.getSpacer().height() );
            }

            return position;
        }

        this.applyStyles = function() {

            var parentObject = this;

            $.each( this.args.css, function( k, v ) {
                parentObject.getElement().css( k, v );
            });
        }

        this.removeStyles = function() {

            var parentObject = this;

            $.each( this.args.css, function( k, v ) {
                parentObject.getElement().css( k, '' );
            });
        }

        this.create();
        return this;
    }

    $.fn.stickify = function( settings ) {

        if ( typeof settings !== 'object' ) {
            settings = {};
        }

        if ( this.length ) {
            this.each( function() {
                settings.selector = $(this);
                new Stickify( settings );
            });
        }
    };

}(jQuery));